import { Borrower } from './borrower.model';
import { BorrowerFactory } from './borrower.factory';
import { Injectable } from '@angular/core';
import { ModelService } from '../../../shared/services/model.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { ApiHttpClient } from 'app/http/clients/api';

@Injectable()
export class BorrowerService extends ModelService<Borrower> {
    protected urlPath = '/borrower';

    constructor (
        private borrowerFactory: BorrowerFactory,
        http: ApiHttpClient
    ) {
        super(http);
    }

    getDuplicates(borrowerId: number, phone: string): Observable<Borrower[]> {
        const params = new HttpParams()
            .set('id', borrowerId.toString())
            .set('phone', phone)
            .set('returnBorrowers', 'true');

        return this.http.get<Borrower[]>('/duplicate-check', { params });
    }

    createFromResponseData(responseData: any): Borrower {
        return this.borrowerFactory.create(responseData);
    }
}
